import React from "react";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import api from "../../Services/Api/api";
import { initAuth } from "../../Modules/auth/startup";
import { isLoggedIn } from "../../Stores/redux/Persist/Selectors";
import AppComponent from "../../Components/AppComponent";
import UnpActions from "../../Stores/redux/UnPersist/Actions";
import PActions from "../../Stores/redux/Persist/Actions";
import { Form, Button } from "react-bootstrap";
import sleep from "../../Modules/utils/sleep";
import Redirect from "../../Components/Navigation/Redirect";
import navigationModule from "../../Modules/navigation/navigationModule";

const getDeviceToken = () => {
  let deviceToken = localStorage.getItem("DEVICE_TOKEN");
  if (!deviceToken) {
    deviceToken = uuidv4();
    localStorage.setItem("DEVICE_TOKEN", deviceToken);
  }

  return deviceToken;
};

class LoginScreen extends AppComponent {
  state = { loading: false, error: "", username: "", password: "" };

  async login(e) {
    try {
      e.preventDefault();

      const {
        state: { username, password, loading },
      } = this;

      if (loading) return;
      this.setAsyncState({ loading: true, error: null });

      const res = await api.post("v1/user/login", {
        username,
        password,
        clientType: "web",
        deviceId: await getDeviceToken(),
      });

      const token = res?.token;

      this.props.setScreenState({ token, impersonator: null }, true, "user");
      await sleep(200);
      await initAuth();
      this.setAsyncState({ loading: false });
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  gotohome() {
    let nextScreen = navigationModule.getQuery("nextScreen") || "/";
    nextScreen = navigationModule.matchCurrentPath(nextScreen)
      ? "/"
      : nextScreen;

    return <Redirect to={nextScreen} />;
  }

  render() {
    const {
      state: { username, password, error, loading },
      props: { isLoggedIn },
    } = this;

    const loginForm = (
      <Form onSubmit={this.login.bind(this)}>
        <h2>Dhing Online Service</h2>
        <div className="subtitle">Welcome back! Please login to continue.</div>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter username"
            value={username}
            onChange={(e) => this.setState({ username: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => this.setState({ password: e.target.value })}
          />
        </Form.Group>

        {error && <div className="errormsg">{error}</div>}

        <Button
          variant="primary"
          type="submit"
          disabled={!username || !password || loading}
        >
          {loading ? "Logging In..." : "Login"}
        </Button>
      </Form>
    );

    return (
      <div className="loginscreen">
        <div className="outer">
          <div className="inner">
            {isLoggedIn ? this.gotohome() : loginForm}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = "LOGIN_SCREEN") =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
